import API_BASE_URL from '../config';

const GOOGLE_CLIENT_ID = '1058155872338-mm2fcul7clj709uc6102b3oaisrucmmn.apps.googleusercontent.com';

export const initializeGoogleSignIn = (onSuccess, onError) => {
  if (typeof window === 'undefined' || !window.google) {
    console.error('Google Sign-In SDK not loaded');
    return;
  }

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: (response) => handleGoogleCallback(response, onSuccess, onError),
  });
};

const handleGoogleCallback = async (response, onSuccess, onError) => {
  try {
    console.log('🔐 Google Sign-In response received');
    
    // Decode the JWT token to get user info
    const credential = response.credential;
    const payload = parseJwt(credential);
    
    console.log('📝 Google user data:', payload);

    // Send to backend for authentication
    const backendResponse = await fetch(`${API_BASE_URL}/api/google-auth/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: payload.email,
        google_id: payload.sub,
        name: payload.name,
        given_name: payload.given_name,
        family_name: payload.family_name,
        photo: payload.picture,
      }),
    });

    const data = await backendResponse.json();

    if (backendResponse.ok && data.access && data.refresh) {
      console.log('✅ Backend authentication successful');
      
      // Store tokens
      localStorage.setItem('accessToken', data.access);
      localStorage.setItem('refreshToken', data.refresh);
      
      // Call success callback
      if (onSuccess) {
        onSuccess(data);
      }
    } else {
      console.error('❌ Backend authentication failed:', data);
      if (onError) {
        onError(data.error || 'Google authentication failed');
      }
    }
  } catch (error) {
    console.error('❌ Google Sign-In error:', error);
    if (onError) {
      onError('Failed to authenticate with Google');
    }
  }
};

// Helper function to decode JWT
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT:', error);
    return null;
  }
};

export const renderGoogleButton = (elementId, options = {}) => {
  if (typeof window === 'undefined' || !window.google) {
    console.error('Google Sign-In SDK not loaded');
    return;
  }

  window.google.accounts.id.renderButton(
    document.getElementById(elementId),
    {
      theme: options.theme || 'outline',
      size: options.size || 'large',
      text: options.text || 'continue_with',
      shape: options.shape || 'rectangular',
      width: options.width || 280,
    }
  );
};

export const promptGoogleOneTap = () => {
  if (typeof window === 'undefined' || !window.google) {
    console.error('Google Sign-In SDK not loaded');
    return;
  }

  window.google.accounts.id.prompt();
};
